import {
    TextHelper,
    SmallTextHelper,
    UrlHelper,
    ArrayHelper
} from '../PrismicHelpers';

export const articlesListHelper = (response, categories = null) => {
    const articlesData = response.results;

    let articlesObject = articlesData.map(article => {
        return {
            uid: SmallTextHelper(article.uid),
            date: SmallTextHelper(article.data.article_date),
            is_on_portal: (!article.data.is_on_portal || article.data.is_on_portal === 'no') ? false : true,
            small_img: UrlHelper(article.data.article_small_img),
            big_img: UrlHelper(article.data.article_big_img),
            alternative_text_image: TextHelper(article.data.alternative_text_image),
            title: TextHelper(article.data.article_title),
            short_description: article.data.article_short_description,
            category: categories && categories.categories && article.data && article.data.category_id.id ? categories.categories.find(category => category.id === article.data.category_id.id) : null
        }
    })

    return {
        articlesList: articlesObject
    }
}

export const singleArticleHelper = response => {
    const singleArticleData = response.results[0].data

    let singleArticleObject = {
        uid: SmallTextHelper(response.results[0].uid),
        date: SmallTextHelper(singleArticleData.article_date),
        is_on_portal: (!singleArticleData.is_on_portal || singleArticleData.is_on_portal === 'no') ? false : true,
        big_img: UrlHelper(singleArticleData.article_big_img),
        small_img: UrlHelper(singleArticleData.article_small_img),
        alternative_text_image: TextHelper(singleArticleData.alternative_text_image),
        title: TextHelper(singleArticleData.article_title),
        short_description: TextHelper(singleArticleData.article_short_description),
        long_description: ArrayHelper(singleArticleData.article_long_description),
        author: singleArticleData && singleArticleData.author && singleArticleData.author.id ? singleArticleData.author.id : null,
        category_id: SmallTextHelper(singleArticleData.category_id.id)
    }

    return {
        singleArticle: singleArticleObject
    };
}

export const categoryHelper = (categories, category_id) => {
    return categories && categories.categories && category_id ? categories.categories.find(category => category.id === category_id) : null
}

export const categoriesHelper = response => {
    let categoriesData = response.results;
    categoriesData = categoriesData.map(category => {
        return {
            id: category.id,
            name: category.data && category.data.category_name ? TextHelper(category.data.category_name) : null
        }
    })
    return {categories: categoriesData}
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/BlogHelpers.js